// frontend/src/components/LoginPage/LoginPage.tsx

import React, { useState } from 'react';
// MUDANÇA 1: Importa o useNavigate
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import logoCcomex from '../../assets/logo-completa.png'; 

export const LoginPage = () => {
    // MUDANÇA 2: Inicializa a função de navegação
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setError('');

        const formBody = new URLSearchParams();
        formBody.append('username', email);
        formBody.append('password', password);

        try {
            const response = await fetch('/api/login/token', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formBody,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.detail || 'Erro ao fazer login.');
            }
            
            console.log('Login bem-sucedido! Token:', data.access_token);
            localStorage.setItem('ccomex_token', data.access_token);

            // MUDANÇA 3: Redireciona para o dashboard em vez de mostrar um alerta
            navigate('/dashboard'); 
            
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="login-container">
            <div className="animations-container">
                <div className="plane plane1"></div>
                <div className="plane plane2"></div>
                <div className="plane plane3"></div>
                <div className="plane plane4"></div>
                <div className="plane plane5"></div>
                <div className="plane plane6"></div>
                <div className="plane plane7"></div>
                <div className="plane plane8"></div>
                <div className="plane plane9"></div>
                <div className="plane plane10"></div>
                
                <div className="ship ship1"></div>
                <div className="ship ship2"></div>
                <div className="ship ship3"></div>
                <div className="ship ship4"></div>
                <div className="ship ship5"></div>
                <div className="ship ship6"></div>
            </div>

            <div className="login-box">
                <img src={logoCcomex} alt="CCOMEX Logo" className="login-logo" />
                
                <p>Bem-vindo! Faça o login para continuar.</p>
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="seuemail@exemplo.com" />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Senha</label>
                        <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Sua senha" />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="login-button">Entrar</button>
                </form>
            </div>
        </div>
    );
};